import * as React from 'react'

import { observer } from 'mobx-react'

import { IProject } from '~/client/graph/types.generated'
import ProjectSelector, {
  ProjectSelectorTriggerSurface,
} from '~/client/src/shared/components/ProjectSelector/ProjectSelector'
import {
  Field,
  FieldLabel,
} from '~/client/src/shared/components/shadcn-ui/field'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import Project from '~/client/src/shared/models/Project'

interface IProps {
  projects: IProject[]
  activeProject: Project
  isProjectCreationAvailable: boolean
  selectProject: (project: IProject) => void
  onNewProjectSelected: () => void
}

const ProjectSelectorBlock: React.FC<IProps> = observer(
  ({
    projects,
    activeProject,
    isProjectCreationAvailable,
    selectProject,
    onNewProjectSelected,
  }: IProps) => {
    const triggerId = 'project-details-project-selector'

    return (
      <div className="tw:flex tw:px-[30px] tw:py-2">
        <Field className="tw:w-[350px]">
          <FieldLabel htmlFor={triggerId}>
            {Localization.translator.selectProject}
          </FieldLabel>
          <ProjectSelector
            isLoading={false}
            isDisabled={false}
            currentProject={activeProject}
            projects={projects}
            onItemSelect={selectProject}
            shouldShowNewProjectItem={isProjectCreationAvailable}
            onNewProjectSelected={onNewProjectSelected}
          >
            <ProjectSelectorTriggerSurface id={triggerId} />
          </ProjectSelector>
        </Field>
      </div>
    )
  },
)

export default ProjectSelectorBlock
